import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../services/common.service';
import {MessageService} from '../../../services/message.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';


@Component({
  selector: 'app-my-messages-dialog',
  templateUrl: './my-messages-dialog.component.html',
  styleUrls: ['./my-messages-dialog.component.scss']
})
export class MyMessagesDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  loading: boolean;
  messages: MatTableDataSource<any> = new MatTableDataSource<any>();
  columnsToDisplay = ['subject', 'sent_date', 'status', 'actions'];
  constructor(
              public commonService: CommonService,
              public toastMessagesService: ToastMessagesService,
              private messageService: MessageService) {
    this.loading = true;
  }

  // constructor(public dialogRef: MatDialogRef<MyMessagesDialogComponent>,
  //             public commonService: CommonService,
  //             public toastMessagesService: ToastMessagesService,
  //             private messageService: MessageService) {
  //   this.loading = true;
  // }

  ngOnInit(): void {

  }
  async ngAfterViewInit() {
    this.commonService.setPaginatorTexts(this.paginator);
    await this.initMyMessages();
  }

  async initMyMessages() {
    try {
      this.loading = true;
      const messageRequest = await this.messageService.getMyMessages();
      this.messages = new MatTableDataSource<any>(messageRequest);
      this.messages.sort = this.sort;
      this.messages.paginator = this.paginator;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loading = false;
    }
  }


  close() {
    // this.dialogRef.close();
  }

  search(value: any) {
    this.messages.filter = value.trim().toLowerCase();
  }

  async preview(id: number) {
    await this.messageService.displayMessage(id);
    // this.dialogRef.close();
  }
}
